import React, { useEffect } from "react";
import { Button } from "@justworkshr/milo-components";
import { trackPageViewUserStep } from "utils/analytics/trackEvent";
import styles from "./ApplyForWC.module.css";
import ApplyForWCComponent from "./components/ApplyForWCComponent";
import LinksComponent from "./components/LinksComponent";
interface IApplyForWCProps {
  setNextStep: () => void;
}

const ApplyForWC = ({ ...props }: IApplyForWCProps): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageViewUserStep(0, "landing page");
  }, []);

  const { setNextStep } = props;

  const handleNext = () => {
    setNextStep();
  };

  return (
    <div className={styles.centerDiv}>
      <ApplyForWCComponent />
      <Button onClick={handleNext}>Get started</Button>
      <LinksComponent />
    </div>
  );
};

export default ApplyForWC;
